RivalIQ.apps.SocialPosts.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    const Collection = Backbone.Collection.mixin({
        mixins: {
            FetchByPostMixin: RivalIQ.utils.FetchByPostMixin
        },

        url: function () {
            const me = this;
            const channel = (me.channel || 'cross_channel');
            const subPath = me.withObservations ? 'observations' : me.metricSubPath;

            return `/api/landscape/${me.landscapeId}/socialPosts/${channel}/posts/${subPath}`;
        }
    });

    const configurations = [
        {
            name: 'Posts',
            metricSubPath: 'post'
        },
        {
            name: 'Hashtags',
            metricSubPath: 'hashtag'
        },
        {
            name: 'PostTagIds',
            metricSubPath: 'post_tag_id'
        }
    ];

    _.reduce(configurations, function (memo, configuration) {
        const config = _.omit(configuration, ['name']);
        return _.set(memo, configuration.name, Collection.extend(config));
    }, collections);


    collections.PostedUrls = Backbone.Collection.mixin({
        mixins: {
            FetchByPostMixin: RivalIQ.utils.FetchByPostMixin
        },

        url: function () {
            const me = this;
            const channel = (me.channel || 'cross_channel');
            return `/api/landscape/${me.landscapeId}/socialPosts/${channel}/posted-urls`;
        }
    });

    const parameterDefaults = function () {
        const keysAndDefaults = {
            channel: RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.CROSS_CHANNEL].channel,
            landscapeId: undefined,
            focusCompanyId: RivalIQ.state.utils.getFocusedCompanyId(),
            timePeriod: RivalIQ.state.view.get('timePeriod'),
            // TODO clean up use of tag here
            tag: undefined,
            type: undefined,
            tweetType: undefined,
            promotedPosts: undefined,
            domainModeFilter: undefined,
            timezone: undefined,

            // By default server determines orderBy and sortOrder
            orderBy: undefined,
            sortOrder: undefined,
            // By default we pull for all companies
            companyIds: undefined,
            limit: 0,

            engagementFloor: undefined,
            minimumDesiredResults: undefined
        };

        _.each(_.keys(RivalIQ.enums.searchFieldNames), function (searchFieldName) {
            keysAndDefaults[searchFieldName] = undefined;
        });

        return keysAndDefaults;
    };

    /**
     * Normalize the given search params.
     * @param params
     * @returns {*}
     */
    collections.Posts.normalizeParams = function (params) {

        params = _.clone(params);

        if (params.timePeriod) {
            params.timePeriod = _.clone(params.timePeriod);
            RivalIQ.utils.timePeriod.rehydrate(params.timePeriod);

            // NOTE we must add `startDate` and `endDate` to `params` so that
            // they will be considered by the cache layer; if they are added
            // later, such as in the collection that is making the request, then
            // requests that would otherwise match will fail to do so
            params.startDate = params.timePeriod.mainPeriodStart.format('YYYY-MM-DD');
            params.endDate = params.timePeriod.mainPeriodEnd.format('YYYY-MM-DD');
            params.compareStartDate = params.timePeriod.comparePeriodStart.format('YYYY-MM-DD');
            params.compareEndDate = params.timePeriod.comparePeriodEnd.format('YYYY-MM-DD');
        }

        if (params.sources) {
            params.channel = RivalIQ.enums.sourceDetails[_.head(params.sources)].channel;
        }

        if (!params.timezone) {
            params.timezone = RivalIQ.utils.timezone.getClientTimezoneString();
        }

        if (!App.utils.dimensionsNeedServerSideSort(params.dimensions)) {
            params.orderBy = params.sortOrder = undefined;
        }

        const hasPostDimensionRequest = _.includes(params.dimensions, 'post');
        const hasNonPostDimensionRequest = !_.includes(params.dimensions, 'post') && !_.isEqual(params.dimensions, ['hashtag']);
        if (hasPostDimensionRequest) {
            params.includePosts = true;
        }
        if (hasNonPostDimensionRequest) {
            params.includeBreakdowns = true;
        }

        _.defaults(params, parameterDefaults());

        // normalize the searchable fields.
        _.each(_.keys(RivalIQ.enums.searchFieldNames), function (searchFieldName) {
            params[searchFieldName] = (_.isString(params[searchFieldName]) ? params[searchFieldName].trim() : '');
        });

        return params;
    };

    collections.Posts.normalizePostedUrlsParams = function (params) {
        params = collections.Posts.normalizeParams(params);

        // these fields are not relevant for postedUrls; there are specific
        // versions of each of these for primaryDomain and canonicalUrl.
        delete params.orderBy;
        delete params.limit;
        delete params.sortOrder;

        return params;
    };

});
